import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navibar from './Components/navbar';

function App() {
  return (
    <div className="App">
      <Navibar />
    </div>
  );
}

export default App;
